type ErrorMessageInput = Error | string | number | boolean | null | undefined;

export default class TooManyRequestsError extends Error {
  isFriendly: boolean;
  code: string;

  constructor(message: ErrorMessageInput) {
    super(message instanceof Error ? message.message : String(message));
    this.isFriendly = true;
    this.code = 'ERRTOOMANYREQUESTS';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
